"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = require("angular");
var QuillClass = require("quill");
require("quill/dist/quill.core.css");
require("quill/dist/quill.snow.css");
require("./so-angular-quill-js.component.css");
var quill_image_drop_module_1 = require("quill-image-drop-module");
var quill_image_resize_module_1 = require("quill-image-resize-module");
var Quill = QuillClass;
Quill.register('modules/imageDrop', quill_image_drop_module_1.ImageDrop);
Quill.register('modules/imageResize', quill_image_resize_module_1["default"]);
// refine quill image format to enable quill-image-resize image style set
var BaseImageFormat = Quill["import"]('formats/image');
var ImageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style'
];
var ImageFormat = /** @class */ (function (_super) {
    __extends(ImageFormat, _super);
    function ImageFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageFormat.formats = function (domNode) {
        return ImageFormatAttributesList.reduce(function (formats, attribute) {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    };
    ImageFormat.prototype.format = function (name, value) {
        if (ImageFormatAttributesList.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            }
            else {
                this.domNode.removeAttribute(name);
            }
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    return ImageFormat;
}(BaseImageFormat));
Quill.register(ImageFormat, true);
var COMPONENT_NAME = 'so.angular-quill-js';
var toolbarConfig = {
    full: [
        [
            { 'header': [false, 1, 2, 3, 4, 5, 6] },
            // { 'font': [] },
            'bold', 'italic', 'underline', 'strike',
            { 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' },
            { 'align': [] },
        ],
        [
            { 'color': [] }, { 'background': [] },
            { 'script': 'sub' }, { 'script': 'super' },
            'clean',
        ],
        ['blockquote', 'link', 'image', 'video'],
    ]
};
var SoAngularQuillJsComponent = /** @class */ (function () {
    function SoAngularQuillJsComponent($scope, $element) {
        this.$scope = $scope;
        this.componentElem = $element[0];
        this.eventListeners = [];
        this.debounceIntervals = [];
        this.debounce = 300;
        this.debounceTime = 0;
        this.typeOptions = { quill: 'quilljs', textAngular: 'textangular' };
        this.richTextBoxType = (localStorage.getItem('richTextBox') || 'quillJS').toLowerCase();
    }
    SoAngularQuillJsComponent.prototype.$postLink = function () {
        var _this = this;
        var toolbar = toolbarConfig.full;
        var editorElem = this.componentElem.querySelector('#quill-editor');
        // @ts-ignore This is a webpack/typescript config issue.
        this.quillEditor = new QuillClass(editorElem, {
            bounds: this.componentElem,
            modules: {
                toolbar: toolbar,
                imageDrop: true,
                imageResize: {}
            },
            theme: 'snow',
            placeholder: this.placeholder,
            readOnly: this.readOnly
        });
        var tooltip = this.quillEditor.theme.tooltip;
        var input = tooltip.root.querySelector("input[data-link]");
        input.dataset.link = 'https://smartorg.com/';
        this.editorChanged = false;
        this.ngModelCtrl.$overrideModelOptions({ debounce: 0 });
        if (this.ngModel) {
            this.setContent(this.ngModel);
        }
        var e1 = this.quillEditor.on('text-change', function (delta, oldDelta, source) { return _this.onTextChange(delta, oldDelta, source); });
        this.eventListeners.push([e1, 'text-change']);
    };
    SoAngularQuillJsComponent.prototype.$onChanges = function (changes) {
        if (changes.ngModel && this.quillEditor) {
            if (!this.editorChanged) {
                if (changes.ngModel.currentValue !== changes.ngModel.previousValue) {
                    this.setContent(changes.ngModel.currentValue);
                }
            }
            this.editorChanged = false;
        }
        if (changes.readOnly && this.quillEditor) {
            this.quillEditor.enable(!this.readOnly);
        }
    };
    SoAngularQuillJsComponent.prototype.$onDestroy = function () {
        for (var _i = 0, _a = this.eventListeners; _i < _a.length; _i++) {
            var _b = _a[_i], event_1 = _b[0], key = _b[1];
            // @ts-ignore Type definition problem.
            event_1.removeListener(key);
        }
    };
    SoAngularQuillJsComponent.prototype.setContent = function (html) {
        // this.$sanitize(html)
        // Skip sanitize here because style got removed.
        var c = this.quillEditor.clipboard.convert(html);
        this.quillEditor.setContents(c);
    };
    SoAngularQuillJsComponent.prototype.isEmpty = function () {
        if ((this.quillEditor.getContents()['ops'] || []).length !== 1) {
            return false;
        }
        return this.quillEditor.getText().trim().length === 0;
    };
    SoAngularQuillJsComponent.prototype.getHtmlContent = function () {
        if (this.isEmpty()) {
            return '';
        }
        return this.componentElem.querySelector('.ql-editor').innerHTML;
    };
    SoAngularQuillJsComponent.prototype.onTextChange = function (text, newText, source) {
        var _this = this;
        if (source !== 'user') {
            return;
        }
        var n = Date.now();
        if (n - this.debounceTime < this.debounce) {
            this.debounceIntervals.forEach(function (i) { return clearInterval(i); });
        }
        this.debounceTime = n;
        this.debounceIntervals.push(setTimeout(function () {
            _this.applyChange();
        }, this.debounce));
    };
    SoAngularQuillJsComponent.prototype.applyChange = function () {
        var _this = this;
        this.$scope.$applyAsync(function () {
            var html = _this.getHtmlContent();
            _this.ngModelCtrl.$setViewValue(html);
            _this.ngModelCtrl.$render();
            _this.editorChanged = true;
            if (_this.onContentChanged) {
                _this.onContentChanged({ content: html });
            }
        });
    };
    return SoAngularQuillJsComponent;
}());
angular.module(COMPONENT_NAME, [
// require('angular-sanitize'),
]).component('soAngularQuillJs', {
    template: require('./so-angular-quill-js.component.html'),
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        placeholder: '@?',
        toolbarSet: '@?',
        rtHeight: '@?',
        onContentChanged: '&?',
        readOnly: '<?',
        ngModel: '<',
        debounce: '<?'
    },
    controller: SoAngularQuillJsComponent
});
exports["default"] = COMPONENT_NAME;
/**
 * All available toolbar options:
 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
 ['blockquote', 'code-block'],
 [{ 'header': 1 }, { 'header': 2 }],               // custom button values
 [{ 'list': 'ordered' }, { 'list': 'bullet' }],
 [{ 'script': 'sub' }, { 'script': 'super' }],     // superscript/subscript
 [{ 'indent': '-1' }, { 'indent': '+1' }],         // outdent/indent
 [{ 'direction': 'rtl' }],                         // text direction
 [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
 [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
 [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
 [{ 'font': [] }],
 [{ 'align': [] }],
 ['clean'],                                        // remove formatting button
 ['link', 'image', 'video']                        // link and image, video
 */
//# sourceMappingURL=so-angular-quill-js.component.js.map


// WEBPACK FOOTER //
// ./app/components/so-rich-text-box/so-angular-quill-js/so-angular-quill-js.component.js